<template>
  <b-container class="bv-example-row">
    <b-row class="text-center d-flex justify-content-center align-items-center">
      <b-col class="bu-index p-2" cols="2">{{index}}</b-col>
      <b-col class="b-action px-2" offset="1" cols="7">{{action}}</b-col>
    </b-row>

    <b-row class="text-center d-flex justify-content-center align-items-center">
      <b-col class="v-line px-0" cols="2"></b-col>
      <b-col cols="8"></b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: ["action", "index"],

  
};
</script>


